/**
 * ============================================================================
 * Static Data
 * ============================================================================
 */

export const KEYCODE_ESC = 27;
export const CONVERSION_SESSION_KEY = 'conversion:values';
